import React from 'react'
import { useTranslation } from 'react-i18next'
import Modal, { Prompt, ModalFooter } from '@ingka/modal'
import Button from '@ingka/button'
import Icon from 'components/uiElements/Icon'

import './styles.scss'

interface KioskIntroPopupProps {
    closeModal: () => void
    isVisible: boolean
}

const KioskIntroPopup = ({ closeModal, isVisible }: KioskIntroPopupProps) => {
    const { t } = useTranslation()

    return (
        <Modal visible={isVisible} handleCloseBtn={closeModal} escapable className="KioskIntroPopup">
            <Prompt
                title={t('kiosk.visualize your dream home')}
                className="kioskPromptBody"
                footer={
                    <ModalFooter compact className="kioskIntroFooter">
                        <Button
                            text={t('kiosk.lets go')}
                            type="secondary"
                            onClick={closeModal}
                            className="dismissButton"
                        />
                    </ModalFooter>
                }
            >
                <p>{t('kiosk.try one of our spaces')}</p>
                <div className="steps">
                    <div className="stepOne">
                        <div className="iconWrapper">
                            <Icon code="pickRoom" svg />
                        </div>
                        <div className="stepText">{t('kiosk.pick a room')}</div>
                    </div>
                    <div className="stepTwo">
                        <div className="iconWrapper">
                            <Icon code="designPlay" svg />
                        </div>
                        <div className="stepText">{t('kiosk.design & Play')}</div>
                    </div>
                    <div className="stepThree">
                        <div className="iconWrapper">
                            <Icon code="shareDesign" svg />
                        </div>
                        <div className="stepText">{t('kiosk.save or share')}</div>
                    </div>
                    <div className="arcOne">
                        <img src={`${ASSET_BUCKET}/kiosk/arcQuarter.svg`} alt="" />
                    </div>
                    <div className="arcTwo">
                        <img src={`${ASSET_BUCKET}/kiosk/arcHorizontal.svg`} alt="" />
                    </div>
                </div>
            </Prompt>
        </Modal>
    )
}

export default KioskIntroPopup
